/**
 * Whether this shell is running inside the SMA print-settings popup iframe.
 *
 * The SMA operation lists open an admin print-settings page in a same-origin
 * iframe at `/admin/<route>?embed=1` (stock-managment-app `PrintSettingsShortcut`).
 * That URL boots a second copy of this shell, so without this flag the popup
 * renders the full app chrome — sidebar included — around the single page it is
 * meant to show. The sidebar's open/closed state is persisted, so it comes up
 * expanded on its own inside the iframe.
 *
 * Detection is captured once at module load and cached on `window`, because the
 * layout later calls `history.replace(pathname)` which strips the query string.
 * Falls back to iframe detection (`window.self !== window.top`) since the popup
 * is the only context that frames this shell. Mirrors
 * `adm-stock-management/src/utils/embed.js`, which hides that bundle's own tabs.
 */
const detect = () => {
  if (typeof window === 'undefined') return false
  if (window.__ADMIN_SHELL_EMBED__) return true

  let flagged = false
  try {
    flagged = new URLSearchParams(window.location.search).get('embed') === '1'
  } catch (e) {
    /* ignore malformed query */
  }
  if (!flagged) {
    try {
      flagged = window.self !== window.top
    } catch (e) {
      // Cross-origin access throws → we are framed.
      flagged = true
    }
  }

  if (flagged) window.__ADMIN_SHELL_EMBED__ = true
  return Boolean(window.__ADMIN_SHELL_EMBED__)
}

const IS_EMBEDDED = detect()

export const isEmbedded = () =>
  (typeof window !== 'undefined' && Boolean(window.__ADMIN_SHELL_EMBED__)) || IS_EMBEDDED

export default isEmbedded
